import React, { Component } from 'react'
import { Col, Label, Row } from 'reactstrap'
import Card from '../../comum/components/Card';
import { inject, observer } from 'mobx-react';
import {get as getLodash} from 'lodash'

@inject("store")
@observer
export default class MercadoriaAcomp extends Component {

    constructor(props){
        super(props)
    }

    render() {
        return this.props.controller.tipoAcompanhamento === "E"
        ? null
        : 
        (<div>
            <h2>Mercadoria</h2>
            <Card>
                <Row>
                    <Col>
                        <Label className="label-secondary">DESCRIÇÃO</Label>
                        <div>
                            <Label className="mb-0 label-disabled">{getLodash(this.props.controller.dadosProcesso, "DscMercadoria")}</Label>
                        </div>
                    </Col>
                </Row>
            </Card>
        </div>)
    }
}



// WEBPACK FOOTER //
// ./src/modules/acompanhamento/components/MercadoriaAcomp.js